import api from "../../../shared/api/apiClient";

const normalizePayload = (payload = {}, entityType = "contact") => ({
  entity_type: payload.entity_type || entityType,
  key: payload.key || payload.field_key,
  label: payload.label,
  data_type: payload.data_type || payload.field_type || "text",

  is_required: !!payload.is_required,
  is_searchable: !!payload.is_searchable,
  is_visible_in_table: !!payload.is_visible_in_table,
  is_active: payload.is_active !== undefined ? !!payload.is_active : true,

  options_json:
    payload.options_json !== undefined
      ? payload.options_json
      : payload.options
      ? { options: payload.options }
      : null,

  default_value: payload.default_value ?? null,
});

export const customFieldsApi = {
  async list(entityType = "contact") {
    const res = await api.get(`/custom-fields/${entityType}`);
    return res.data;
  },

  async create(payload, entityType = "contact") {
    const res = await api.post(
      "/custom-fields",
      normalizePayload(payload, entityType)
    );
    return res.data;
  },

  async update(id, payload) {
    const res = await api.put(`/custom-fields/${id}`, payload);
    return res.data;
  },

  async delete(id) {
    const res = await api.delete(`/custom-fields/${id}`);
    return res.data;
  },
};

export const contactCustomFieldsApi = {
  async list() {
    return customFieldsApi.list("contact");
  },

  async create(payload) {
    return customFieldsApi.create(
      {
        ...payload,
        entity_type: payload.entity_type || "contact",
      },
      "contact"
    );
  },

  async update(id, payload) {
    return customFieldsApi.update(id, payload);
  },

  async delete(id) {
    return customFieldsApi.delete(id);
  },
};

export const productCustomFieldsApi = {
  async list() {
    return customFieldsApi.list("product");
  },

  async create(payload) {
    return customFieldsApi.create(
      {
        ...payload,
        entity_type: payload.entity_type || "product",
      },
      "product"
    );
  },

  async update(id, payload) {
    return customFieldsApi.update(id, payload);
  },

  async delete(id) {
    return customFieldsApi.delete(id);
  },
};
